import Base from '@components/layouts/base';
import Footer from '@components/partials/common/footer';
import Header from '@components/partials/common/header';
import PopupManager from '@components/partials/list/popupManager';
import AdvancedModelGrid from '@components/partials/search/advancedModelGrid';
import { getCategoryApi } from '@data/categoryApi';
import styles from '@styles/scss/list/_listPage.module.scss';
import { Banner } from 'lib/types/item/banner';
import { FooterText } from 'lib/types/item/footer';
import { FooterLinks } from 'lib/types/item/footerLinks';
import { NavbarItem } from 'lib/types/item/navBarItem';
import { PerformerCard } from 'lib/types/item/performerCard';
import { Popup } from 'lib/types/item/popup';
import { SidebarItem } from 'lib/types/item/sideBarItem';
import { GetStaticProps } from 'next';
import Head from 'next/head';

export default function Index({
    performerCards,
    navBarItem,
    sideBarItem,
    banner,
    footer,
    footerLinks,
    language,
    popupText,
}: {
    performerCards: PerformerCard[];
    navBarItem: NavbarItem[];
    sideBarItem: SidebarItem[];
    stickyFooter: string;
    banner: Banner;
    footer: FooterText;
    footerLinks: FooterLinks;
    language: string;
    popupText: Popup;
}): JSX.Element {
    return (
        <>
            <Base currentLang={language} performer="">
                <Head>
                    <title>Advanced Search Results</title>
                    <link
                        rel="canonical"
                        href={
                            language === 'en'
                                ? `https://www.camrabbit.sex/search`
                                : `https://www.camrabbit.sex/${language}/search`
                        }
                    />
                    <meta name="robots" content="noindex,follow" />
                </Head>
                <Header
                    sideBarItems={sideBarItem}
                    navBarItems={navBarItem}
                    currentLang="en"
                    gender="girls"
                />
                <div className={styles.listPage}>
                    <div className={styles.listContainer}>
                        <AdvancedModelGrid
                            performerCards={performerCards}
                            banner={banner}
                            currentLang={language}
                        />
                    </div>
                </div>
                <Footer
                    footerText={footer}
                    footerLinks={footerLinks}
                    currentLang="en"
                    gender="girls"
                />
                <PopupManager gender="girls" currentLang={language} popupText={popupText} />
            </Base>
        </>
    );
}

export const getStaticProps: GetStaticProps = async (context: any) => {
    const category = 'home';
    const language = context.locale;
    const categoryApi = await getCategoryApi(category, language, '');
    if (!category) {
        return {
            notFound: true
        };
    }

    return {
        props: {
            category: categoryApi.categoryData.category,
            stickyFooter: categoryApi.categoryData.category.sticky_footer,
            banner: categoryApi.categoryData.category.banner,
            footer: categoryApi.categoryData.category.footer,
            sideBarItem: categoryApi.categoryData.sidebarItems,
            performerCards: categoryApi.categoryData.performerCards,
            navBarItem: categoryApi.categoryData.navbarItems,
            footerLinks: categoryApi.categoryData.footerLinks,
            language: language,
            cta: categoryApi.categoryData.see_more_girls,
            popupText: categoryApi.categoryData.popup
        },
        revalidate: 1
    };
};
